export type HeaderDataType = {
  categoryFirst: string;
  categorySecond: string;
  description: string;
  helpDescription?: JSX.Element;
};

export const categoryMap: Record<string, HeaderDataType> = {
  '/dash-board': {
    categoryFirst: '대시보드',
    categorySecond: '주문조회',
    description: '등록된 주문내역을 조회합니다',
  },

  '/orders': {
    categoryFirst: '주문관리',
    categorySecond: '주문조회',
    description: '등록된 주문내역을 조회합니다',
  },
  '/orders/update': {
    categoryFirst: '주문관리',
    categorySecond: '주문등록',
    description: '엑셀파일로 주문을 등록합니다',
    helpDescription: (
      <>
        <div>1. 엑셀파일을 드래그 혹은 탐색기에서 선택하여 추가합니다.</div>
        <div>
          2-1. 신규 주문 항목은 새로 추가된 주문들로, 별도의 관리가 필요하지
          않습니다.
        </div>
        <div>
          2-2. 중복된 주문 항목은 주문번호가 중복되는 주문이 이미 존재하는
          경우로서,
        </div>
        <div>
          주문 좌측에 위치한 체크박스를 선택하면 기존 주문은 지워지며 체크된
          주문이 새로 등록됩니다.
        </div>
      </>
    ),
  },
  '/production-add': {
    categoryFirst: '생산관리',
    categorySecond: '생산등록',
    description: '생산일정을 등록 및 수정합니다',
  },
  '/production-overview': {
    categoryFirst: '생산관리',
    categorySecond: '생산현황',
    description: '금일의 생산일정을 조회합니다',
  },
  '/production-progress': {
    categoryFirst: '생산관리',
    categorySecond: '생산진행',
    description: '생산작업 현황을 확인하고 진행합니다',
  },
  '/production-inbound': {
    categoryFirst: '생산관리',
    categorySecond: '생산입고',
    description: '금일의 생산량, 소모량을 확인하고 엑셀파일로 출력합니다',
  },
  '/stock-history-log': {
    categoryFirst: '생산관리',
    categorySecond: '소모품 이력',
    description: '소모항목의 상세 이력을 조회합니다',
  },
  '/machine': {
    categoryFirst: '생산관리',
    categorySecond: '기계등록',
    description: '생산에 사용되는 기계를 등록합니다',
  },
  '/machine-assignment': {
    categoryFirst: '생산관리',
    categorySecond: '기계배정',
    description: '작업자 계정과 기계를 연동합니다.',
  },
  '/stock': {
    categoryFirst: '생산관리',
    categorySecond: '재고현황',
    description: '금일의 재고 현황을 조회합니다.',
  },
  '/trader/update': {
    categoryFirst: '기초등록',
    categorySecond: '거래처 정보등록',
    description: '엑셀파일로 거래처를 등록합니다',
  },
  '/trader/abbreviation': {
    categoryFirst: '기초등록',
    categorySecond: '거래처 약칭 등록',
    description: '페이지에서 사용될 거래처의 약칭을 등록합니다',
  },
  '/item/abbreviation': {
    categoryFirst: '기초등록',
    categorySecond: '품목 약칭 등록',
    description: '페이지에서 사용될 품목의 약칭을 등록합니다',
  },
  '/delivery/set': {
    categoryFirst: '배송',
    categorySecond: '배송묶음',
    description: '배송일자와 담당자, 주문목록을 배정합니다',
    helpDescription: (
      <>
        <h4>수동 배정</h4>
        <div>1. 연, 월 정보를 선택합니다.</div>
        <div>2. 날짜정보를 선택하여 추가합니다.</div>
        <div>
          3. 담당자의 이름을 클릭 및 드래그하여 추가된 날짜 내부에 위치시킵니다.
        </div>
        <div>
          4. 미배정된 주문 혹은 이미 배정된 주문을 드래그하여 원하는곳에
          위치시킵니다.
        </div>
        <h4>일괄 배정</h4>
        <div>1. 연, 월 정보를 선택합니다.</div>
        <div>2. 날짜정보를 선택하여 추가합니다.</div>
        <div>
          3. 담당자의 이름을 클릭 및 드래그하여 추가된 날짜 내부에 위치시킵니다.
        </div>
        <div>4. 담당자 이름 좌측에 위치한 체크박스를 하나 선택합니다.</div>
        <div>
          5. 미배정 주문 목록 좌측에 위치한 체크박스를 원하는 만큼 클릭하고,
          적용하기 버튼을 클릭합니다.
        </div>
      </>
    ),
  },
  '/delivery/list': {
    categoryFirst: '배송',
    categorySecond: '배송조회',
    description: '배송일자와 담당자, 주문목록을 조회합니다',
  },
  '/bom': {
    categoryFirst: '기초등록',
    categorySecond: '소모량등록',
    description: '생산품의 소모항목과 소모량을 등록합니다',
  },
  '/parcel': {
    categoryFirst: '배송',
    categorySecond: '택배송장변환',
    description: '주문을 택배송장 엑셀양식에 맞게 변환합니다',
  },
  '/parcel-item': {
    categoryFirst: '엑셀변환 정보 등록',
    categorySecond: '품목 택배정보 등록',
    description: '택배송장 변환 시 품목의 변환값을 설정합니다',
  },
  '/parcel-trader': {
    categoryFirst: '엑셀변환 정보 등록',
    categorySecond: '거래처 택배정보 등록',
    description: '택배송장 변환 시 거래처의 변환값을 설정합니다',
  },
  '/attendance': {
    categoryFirst: '데이터관리',
    categorySecond: '근태관리 엑셀변환',
    description: '세콤매니저 엑셀양식을 근태양식으로 변환합니다',
    helpDescription: (
      <>
        <div>1. 변환하고자 하는 근태파일 원본의 연, 월을 선택합니다.</div>
        <div>2. 파일 등록 버튼을 클릭하고 파일을 업로드합니다.</div>
        <div>
          3. 추출된 데이터를 확인 및 수정 후, 파일 저장 버튼을 클릭합니다.
        </div>
        <div style={{ height: '5px' }} />
        <div>
          * [근무일수]는 근무스케줄이 휴일, 결근이 아닌 날의 합산이며 5일 만근
          시마다 1일씩 더해집니다.{' '}
          <strong style={{ border: '3px solid green' }}>초록 테두리</strong>로
          표시됩니다.
        </div>
        <div>
          만약 <strong style={{ backgroundColor: '#ffd1d1' }}>결근</strong>이
          포함되어있을 경우, 해당 주 일요일의 유급휴일은 합산되지 않으며
          [유급휴일무급처리] 항목 및 [결근] 항목에 1일이 합산됩니다.
        </div>
        <div style={{ height: '5px' }} />
        <div>
          * [근무단축 시간]은 수정사유에 단축(n시간)이 기록된 항목들의 합산으로
          적용되며,{' '}
          <strong style={{ border: '3px solid black' }}>검정 테두리</strong>로
          표시됩니다.
        </div>
        <div style={{ height: '5px' }} />
        <div>
          * [연가(일)]의 경우, 근무스케줄이 [연가]인 항목은 일 수로 세어지고{' '}
          <strong style={{ backgroundColor: '#ffc9aa' }}>주황 배경색</strong>
          으로 표시됩니다.
        </div>
        <div style={{ height: '5px' }} />
        <div>
          * [연가(시간)]의 경우, 수정사유에 [단축(n시간)]이 기록된 항목들의
          합산으로 적용되며,{' '}
          <strong style={{ border: '3px solid #ffc9aa' }}>주황 테두리</strong>로
          표시됩니다.
        </div>
        <div style={{ height: '5px' }} />
        <div>
          * [연장근로]의 경우, 수정사유가 존재할 경우 [연장(n시간)]이 기록된
          항목들의 합산으로 적용되며,
        </div>
        <div style={{ height: '5px' }} />
        <div>
          수정사유 없이 [연장근무 시간]만 존재할 경우 시간을 내림하여 적용(평일
          2시간 이하, 주말 8시간 이하)로 적용됩니다.{' '}
          <strong style={{ border: '3px solid #ec4bff' }}>보라 테두리</strong>로
          표시됩니다.
        </div>
        <div style={{ height: '5px' }} />
        <div>
          * [병가(일)]의 경우, 근무스케줄이 [병가]인 항목은 일 수로 세어지고{' '}
          <strong style={{ backgroundColor: '#d5e8ff' }}>푸른 배경색</strong>
          으로 표시됩니다.
        </div>
        <div style={{ height: '5px' }} />
        <div>
          * [병가(시간)]의 경우, 수정사유에 [병가(n시간)]이 기록된 항목들의
          합산으로 적용되며,{' '}
          <strong style={{ border: '3px solid #64B5F6' }}>푸른 테두리</strong>로
          표시됩니다.
        </div>
      </>
    ),
  },
  '/orders/address-verify': {
    categoryFirst: '주문관리',
    categorySecond: '주문 배송지 미등록 항목',
    description: '유효하지 않은 주소지를 직접 수정하여 입력합니다',
    helpDescription: (
      <>
        <h4>
          엑셀로 등록된 주문들 중, 주소지가 유효하지 않은 항목들의 주소를 직접
          등록하는 페이지입니다.
        </h4>
        <div>
          1. 필요에 따라 [주소] 헤더 셀 우측을 드래그하고 칸을 넓혀 돋보기
          아이콘이 보여지도록 합니다.
        </div>
        <div>2. 주소를 직접 검색하고 선택합니다.</div>
        <div>3. 필요에 따라 상세주소를 입력합니다.</div>
        <div>
          4. 모든 수정이 완료되었으면 상단의 [전체 저장]버튼을 통해 저장합니다.
        </div>
      </>
    ),
  },
  '/orders/address-modify': {
    categoryFirst: '주문관리',
    categorySecond: '주문 배송지 변경',
    description: '주문의 배송지를 수정합니다',
  },
  '/orders/emm-shop-changed': {
    categoryFirst: '주문관리',
    categorySecond: '자사쇼핑몰 주문 변경내역',
    description: '변경사항이 감지된 자사쇼핑몰의 주문내역을 확인합니다',
    helpDescription: (
      <>
        <h4>
          자사쇼핑몰 주문목록 중, 수정사항이 감지된 주문들을 확인하는
          페이지입니다.
        </h4>
        <div>
          1. 이카운트ERP에서는 외부 플랫폼에서 주문을 직접 수정하는 기능을
          제공하지 않기에,
        </div>
        <div>
          수정사항은 필요에 따라 이카운트ERP에 직접 반영해주셔야 합니다.
        </div>
        <div>
          2. 수정이 완료되었다면, 혹은 수정이 필요하지 않다면 좌측 [확인]버튼을
          눌러 알림을 제거합니다.
        </div>
      </>
    ),
  },
  '/analysis/chart': {
    categoryFirst: '분석',
    categorySecond: '시각데이터',
    description: '등록된 주문을 기반으로 시각데이터를 확인합니다',
  },
  '/analysis/order-statistics': {
    categoryFirst: '분석',
    categorySecond: '기간별 주문데이터 조회',
    description: '일정기간동안의 주문 통계를 확인합니다',
  },
  '/analysis/potential-customer-orders': {
    categoryFirst: '분석',
    categorySecond: '잠재고객 주문데이터 조회',
    description:
      '나라장터의 주문데이터를 기반하여 잠재고객들의 목록을 확인합니다',
  },

  /** ADMIN */
  '/account-manage': {
    categoryFirst: '계정관리',
    categorySecond: '',
    description: '계정정보를 관리합니다',
  },
  '/data-manage': {
    categoryFirst: '데이터관리',
    categorySecond: '',
    description: '데이터를 관리합니다',
  },
  '/scheduler-manage': {
    categoryFirst: '스케줄러 관리',
    categorySecond: '',
    description: '스케줄러를 관리합니다',
  },
};
